import { reactive, watch } from "vue"

const formBaseStorage = (state, mutations, actions, getters) => ({
	state,
	mutations: {
		...mutations,
	},
	actions: {
		...actions,
	},
	getters: {
		...getters,
	},
})

function createStorage(defaultState, mutations, actions, getters) {
	mutations ??= {}
	actions ??= {}
	getters ??= {}

	return formBaseStorage(
		() => reactive({ ...defaultState }),
		mutations,
		actions,
		getters
	)
}

function createPersistentStorage(
	namespace,
	defaultState,
	mutations,
	actions,
	getters
) {
	mutations ??= {}
	actions ??= {}
	getters ??= {}

	const state = reactive({ ...defaultState })

	const save = () => {
		localStorage.setItem(namespace, JSON.stringify(state))
	}

	const sync = () => {
		const localContent = JSON.parse(localStorage.getItem(namespace)) ?? {}

		for (const key of Object.keys(state)) {
			if (Object.hasOwnProperty.call(localContent, key)) {
				state[key] = localContent[key]
			}
		}

		save()
	}

	sync() // overwrite defaultState with saved values & remove unused entries
	watch(state, save) // automatically save when state is mutated

	return formBaseStorage(() => state, mutations, actions, getters)
}

export { createStorage, createPersistentStorage }
